import { securePost } from "config/encryption_decryption/get_post_encryptDecrypt";

export const loginUser = async (username: string, password: string, type: string) => {
  return securePost("/api/auth/login", { username, password, type });
};

export const logOutUser = async () => {
  return securePost("/api/auth/logout", {});
};

export const LoginGoogleapi = async (credential: string) => {
  return securePost("/api/auth/googlelogin", { credential });
};

/**
 * Verifies the signed-in user's CURRENT password server-side.
 *
 * Replaces the old getPassword(user_email), which returned the account's md5
 * hash to the browser so it could be compared client-side. The hash is a
 * credential, and the email was client-supplied, so any authenticated user could
 * fetch anyone's (incident 2026-08-26). Identity now comes from the session and
 * only a boolean comes back.
 */
export const verifyCurrentPassword = async (password: string) => {
  return securePost("/api/user/getPassword", { password });
};
